import moment from 'moment'
import { ComponentProps } from 'react'

import BaseField from '../BaseField'
import { IndependentDatetimePicker } from '.'
import { RawTimePickerDefault } from './RawTimePickerDefault'

type Props = ComponentProps<typeof IndependentDatetimePicker>

/**
 *
 * @initialValue format: hh:mm:ss
 * @returns
 */
export const RawIndependentTimePicker = ({
  id,
  name,
  initialValue,
  value,
  readonly,
  onChange,
  ...props
}: Props) => {
  let formattedValue = undefined

  if (initialValue || value) {
    formattedValue = new Date(
      moment(value || initialValue, 'hh:mm:ss').toDate()
    )
  }

  return (
    <BaseField {...props}>
      <RawTimePickerDefault
        id={id || name}
        name={name}
        onChange={(value) => onChange?.(value)}
        readOnly={readonly}
        value={formattedValue}
        {...props}
      />
    </BaseField>
  )
}
